import React from 'react';
import ExternalLinkButton from '../../../../../elements/Button/ExternalLinkButton/ExternalLinkButton';

function ScheduleContentButton(props) {
    const { event, session } = props,
        { session_content_url } = session;

    if (!session_content_url) return null;

    return (
        <ExternalLinkButton
            style={{
                backgroundColor: event.settings.primary_color,
                color: 'white',
                minWidth: '100%',
            }}
            {...session}
            programId={session.id}
            eventId={event.id}
        />
    );
}

export default ScheduleContentButton;
